import React from 'react';
import { connect } from 'react-redux';
import { displayValueWithSymbol } from '../../../../utils/price';
import properties from '../../../../modules/ajio-util/properties';

const imageBaseUrl = properties.getProperty('imageBaseUrl');

function isEmpty(obj) {
  if (obj) {
    return Object.keys(obj).length === 0;
  }
  return true;
}

const PriceSection = ({ breakValues }) => {
  if (isEmpty(breakValues)) {
    return (
      <div className="price-section">
        <span>Price details are not available at the moment. </span>
      </div>
    );
  }
  return (
    <>
      {breakValues.map(priceObj => {
        const { label, description, price, discountedPrice } = priceObj || {};
        const actualPrice = discountedPrice || price || '';
        const isTotal = label ? label.toLowerCase() === 'total' : false;
        const totalClass = isTotal ? 'boldText' : '';
        return price || discountedPrice ? (
          <div className="price-section">
            <div className="price-key">
              <span className={totalClass}>{label}</span>
              {description ? <div className="price-desc">{`(${description})`}</div> : null}
            </div>
            <div className="price-dots">
              <div className="dots" />
            </div>
            <div className="price-value">
              {price && discountedPrice ? (
                <div className={`price-disc ${totalClass} strikethrough`}>
                  {displayValueWithSymbol(price)}
                </div>
              ) : null}
              <span className={totalClass}>{displayValueWithSymbol(actualPrice)}</span>
            </div>
          </div>
        ) : null;
      })}
    </>
  );
};

class PriceBreakUp extends React.Component {
  render() {
    const {
      priceBreakUp: { priceBreakUpObject, hasPriceBreakUp },
      selectedSizeCode = ''
    } = this.props;
    if (!hasPriceBreakUp) {
      return null;
    }
    return (
      <div className="comp-section">
        <h4 className={`align-center ${!selectedSizeCode ? 'lessMargin' : ''}`}>
          <span>Price Details</span>
        </h4>
        {selectedSizeCode ? (
          <PriceSection breakValues={priceBreakUpObject[selectedSizeCode]} />
        ) : null}
        {!selectedSizeCode ? (
          <div className="price-Alert">
            <span className="img-warning">
              <img src={`${imageBaseUrl}/static/img/sizeSelectWarning.svg`} alt="Alert icon" />
            </span>
            <span className="bold-text">Select Size/ Metal Purity</span> to view price details
          </div>
        ) : null}
      </div>
    );
  }
}

const getPricebreakUp = state => {
  const { baseOptions = [], variantOptions } = state.product.productDetails;
  let sizeVariant;
  for (let i = 0; i < baseOptions.length; i += 1) {
    switch (baseOptions[i].variantType) {
      case 'FnlSizeVariant':
        sizeVariant = baseOptions[i].options;
        break;
      default:
    }
  }
  if (!sizeVariant) {
    sizeVariant = variantOptions;
  }
  const priceBreakUpObject = sizeVariant.reduce((acc, { code, priceBreakUp }, index) => {
    acc[code] = priceBreakUp;
    return acc;
  }, {});
  let hasPriceBreakUp = true;
  if (Object.values(priceBreakUpObject).every(el => el === undefined)) {
    hasPriceBreakUp = false;
  }
  return {
    priceBreakUpObject,
    hasPriceBreakUp
  };
};

const mapStateToProps = state => {
  return {
    priceBreakUp: getPricebreakUp(state),
    selectedSizeCode: state.product.selectedSizeCode
  };
};

export default connect(mapStateToProps, null)(PriceBreakUp);
